var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 11.0732C2 5.82656 6.25332 1.57324 11.5 1.57324C16.7467 1.57324 21 5.82656 21 11.0732C21 13.3369 20.2083 15.4156 18.8866 17.0476L22.5591 20.7201C22.9497 21.1106 22.9497 21.7438 22.5591 22.1343C22.1686 22.5249 21.5354 22.5249 21.1449 22.1343L17.4722 18.4616C15.8405 19.7822 13.7626 20.5732 11.5 20.5732C6.25332 20.5732 2 16.3199 2 11.0732ZM11.5 3.57324C7.35788 3.57324 4 6.93113 4 11.0732C4 15.2154 7.35788 18.5732 11.5 18.5732C15.6421 18.5732 19 15.2154 19 11.0732C19 6.93113 15.6421 3.57324 11.5 3.57324Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.5287dc03.svg";
export { ForwardRef as ReactComponent };